export const PATIENTS_LIMIT = 15;
export const APPOINTMENTS_LIMIT = 5;
export const SEARCH_LIMIT = 10;
export const LOG_LIMIT = 9;
export const ACTIVATION_CODE_LIMIT = 9;
export const CLINICIANS_LIMIT = 12;